import React from "react"
import PropTypes from "prop-types"
import { useNavigate, useLocation } from "react-router-dom"
import { Tabs } from "../index"
import { ArrowLeft } from "../Icon"
import "./ProfileNav.scss"

export default function ProfileNav({
  tabs,
  backTo,
  backLabel,
  onBack,
  actions,
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const segments = location.pathname.split("/")
  const currentSegment = segments.at(-1)

  // Match current URL segment to tab value (empty string = first/default tab)
  const activeTab =
    tabs.find((t) => t.segment === currentSegment)?.segment ||
    tabs.find((t) => t.segment === "")?.segment ||
    ""

  const handleBack = () => {
    if (onBack) {
      onBack()
    }
    navigate(backTo || "..")
  }

  return (
    <div className="sp-nav-container profile-nav-bar">
      <button
        className="ps-back-btn profile-nav-back"
        onClick={handleBack}
        aria-label={backLabel || "Back"}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleBack()
          }
        }}
        data-testid="profile-nav-back"
      >
        <ArrowLeft size={14} />
        <span className="profile-nav-back-label">{backLabel || "Back"}</span>
      </button>

      <Tabs.Root
        value={activeTab}
        onValueChange={(val) => navigate(val || ".")}
        className="profile-nav-tabs-root"
      >
        <Tabs.List
          className="sp-tabs-tray profile-nav-tabs-list"
          aria-label="Profile sections"
        >
          {tabs.map((tab) => (
            <Tabs.Trigger
              key={tab.segment}
              value={tab.segment}
              className="sp-tab-pill"
              data-testid={`profile-nav-tab-${tab.segment || "default"}`}
            >
              {tab.label}
            </Tabs.Trigger>
          ))}
        </Tabs.List>
      </Tabs.Root>

      <div className="sp-spacer" />

      {actions && (
        <div className="sp-switches-container">
          <div className="sp-switches">{actions}</div>
        </div>
      )}
    </div>
  )
}

ProfileNav.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      segment: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  backTo: PropTypes.string,
  backLabel: PropTypes.string,
  onBack: PropTypes.func,
  actions: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
}
